import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { BasicLayoutComponent } from 'src/app/common/layouts/basicLayout.component';
import { AuthGuard, PrepareGuard } from 'src/app/core/core.module';
import { JobSearchComponent } from './job-search/job-search.component';
import { JobDetailComponent } from './job-detail/job-detail.component';
import { JobDialogComponent } from './job-dialog/job-dialog.component';
import { MaterialDialogComponent } from './material-dialog/material-dialog.component';
import { TimeDialogComponent } from './time-dialog/time-dialog.component';
import { ActiveJobSearchComponent } from './active-job-search/active-job-search.component';
import { PurchaseOrderLineDialogComponent } from './purchase-order-line-dialog/purchase-order-line-dialog.component';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        RouterModule.forChild([
            {
                path: 'jobs',
                component: BasicLayoutComponent,
                children: [
                    { path: '', redirectTo: 'search', pathMatch: 'full' },
                    { path: 'search', component: JobSearchComponent, data: { title: 'Jobs' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'active', component: ActiveJobSearchComponent, data: { title: 'Active Jobs' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: ':id', component: JobDetailComponent, data: { title: 'Detail' }, canActivate: [AuthGuard, PrepareGuard] },
                    // { path: ':id', component: JobDetailComponent, data: { title: 'Detail' }, canActivate: [AuthGuard, PrepareGuard], canDeactivate: [PendingChangesGuard] },
                ],
            },
        ]),
    ],
    declarations: [JobSearchComponent, JobDetailComponent, JobDialogComponent, MaterialDialogComponent, TimeDialogComponent, ActiveJobSearchComponent, PurchaseOrderLineDialogComponent]
})
export class JobsModule {}
